import React from 'react';
import { BtwModal } from './BtwModal';
import { Pin } from './Pin';
import { ScrollArea } from './ScrollArea';
import { Stack } from './Stack';
export function FullscreenModal(props) {
    const { children, trigger } = props;
    return (React.createElement(BtwModal.Root, null,
        React.createElement(BtwModal.Trigger, { asChild: true }, trigger),
        React.createElement(BtwModal.Content, { container: null, contentClassName: "w-screen h-screen max-w-[calc(100vw-48px)] max-h-[calc(100vh-48px)]", justify: "between", size: "full" },
            React.createElement(ScrollArea, { className: "h-screen max-h-[calc(100vh-48px)] w-screen max-w-[calc(100vw-48px)]" },
                React.createElement(Stack, { align: "center", justify: "center", className: "min-h-full p-6" }, children)),
            React.createElement(Pin.Tr, { className: "p-5" },
                React.createElement(BtwModal.CloseButton, { size: "intermediate", variant: "secondary" })))));
}
